/**
 * UI tabs to create tabs (nav and required actions)
 *
 * @module app/components/Tabs
 */
import jQuery from 'jquery';

/**
 * Initialize tabs
 *
 * @param {Object} element main container wrapping the Tab
 *
 * save initial title
 *
 * @returns {void}
 *
 * @private
 */
var initTabs = function (element) {

    var buttonsTabs = element.find('.tabs__nav-item');
    var typeTabs = element.attr('data-tabs');
    bindEvents(element, buttonsTabs, typeTabs);
    checkBreakPoint(element);
};

/**
 * Assign Events to the Tab navigation
 *
 * @param {Object} element main container wrapping the Tab
 * @param {Object} buttons tabs buttons
 * @param {String} typeAction defined through data attribute
 *
 * @returns {void}
 *
 * @private
 */
var bindEvents = function (element, buttons, typeAction) {

    var onTabButtonClick = function () {

        var targetSection = jQuery(this).attr('data-link-panel'),
            title = jQuery(this).attr('data-name');

        unsetActivePanel(element);
        setActivePanel(element, targetSection);
        jQuery(this).addClass('tabs__nav-item--active');
        defineActions(typeAction, title);
        return false;
    };

    buttons.off('click.tabs').on('click.tabs', onTabButtonClick);
};

/**
 * Assign methods depending on data-attr
 *
 * @param {String} typeAction defined through data attribute
 * @param {String} title of the section
 *
 * @returns {void}
 *
 * @private
 */
var defineActions = function (typeAction, title) {

    switch (typeAction) {
    case 'classic':
        // CLASSIC TABS
        setTitle(title);
        break;
    default:
    }

    window.dispatchEvent(new Event('resize'));
};

/**
 * Reset the original title when tabs are destroyed
 *
 * @param {String} title of the section
 *
 * @returns {void}
 *
 * @private
 */
var setTitle = function (title) {

    jQuery('h1[data-role="main-title-page"]').text(title);
};

/**
 * Remove all active classes
 *
 * @param {Object} element main container wrapping the Tab
 *
 * @returns {void}
 *
 * @private
 */
var unsetActivePanel = function (element) {

    element.find('.tabs__nav-item--active')
        .removeClass('tabs__nav-item--active');
    element.find('.tabs__panels-panel--active')
        .removeClass('tabs__panels-panel--active');

    jQuery('.tabs__panel--out').find('.tabs__panels-panel--active')
        .removeClass('tabs__panels-panel--active');
};

/**
 * Add the active class to the correct panels
 *
 * @param {Object} element main container wrapping the Tab
 * @param {String} selector for the selected panel
 *
 * @returns {void}
 *
 * @private
 */
var setActivePanel = function (element, selectedPanel) {

    var panelToActive = element.find('[data-panel="' + selectedPanel + '"]');

    element.find('[data-link-panel="' + selectedPanel + '"]')
        .addClass('tabs__nav-item--active');

    if (panelToActive.length > 0) {
        panelToActive.addClass('tabs__panels-panel--active');
    } else {
        panelToActive = jQuery('.tabs__panel--out').find('[data-panel="' + selectedPanel + '"]');
        panelToActive.addClass('tabs__panels-panel--active');
    }
};

/**
 * Check when the Tabs should appear
 *
 * @param {Object} element main container wrapping the Tab
 *
 * @returns {void}
 *
 * @private
 */
var checkBreakPoint = function (element) {

    var indicatorBreakpoint = element.find('.breakpoint_ui'),
        state = indicatorBreakpoint.css('content');

    jQuery(window).resize(function () {
        state = indicatorBreakpoint.css('content');

        if (indicatorBreakpoint.length) {
            activateClassPanel(element, state);
            deActivateClassPanel(element, state);
        }
    });
};

/**
 * Activate panel class
 *
 * @param {Object} element main container wrapping the Tab
 * @param {String} state indicating the breakpoint
 *
 * @returns {void}
 *
 * @private
 */
var activateClassPanel = function (element, state) {

    // Don't change: '\'--\''
    if (state === '\'on\'') {
        //CASE MOBILE
        setTitle(element.find('.tabs__nav-item.tabs__nav-item--active').attr('data-name'));
    }
};

/**
 * Deactivate tabs
 *
 * @param {Object} element main container wrapping the Tab
 * @param {String} state indicating the breakpoint
 *
 * @returns {void}
 *
 * @private
 */
var deActivateClassPanel = function (element, state) {

    // Don't change: '\'--\''
    if (state === '\'off\'') {
        //CASE DESKTOP
        setTitle(element.find('.tabs__nav-item:eq(0)').attr('data-name'));
    }
};

var api = {


    /**
     * Methods to be public
     *
     * @type {Object}
     *
     * @returns {void}
     *
     * @public
     */
    init: function () {

        jQuery('.tabs').each(function (key) {
            initTabs(jQuery('.tabs').eq(key));
        });
    },
};

export default api;
